import React, { useState } from 'react';

function FAQItem({ question, answer, isOpen, onToggle }) {
  return (
    <div className="border-b border-brown/15">
      <button
        onClick={onToggle}
        className="w-full flex items-center justify-between gap-5 py-7 text-left group"
        aria-expanded={isOpen}
      >
        <span className="font-serif text-[20px] text-warm-black font-medium leading-[1.3] group-hover:text-brown transition-colors duration-200">
          {question}
        </span>
        <span 
          className={`flex-shrink-0 w-10 h-10 rounded-full border flex items-center justify-center text-[20px] font-light transition-all duration-300 ${
            isOpen 
              ? 'bg-warm-black text-cream border-warm-black rotate-45' 
              : 'bg-transparent text-warm-black border-brown/25'
          }`}
        >
          +
        </span>
      </button>
      <div 
        className={`overflow-hidden transition-all duration-400 ease-out ${
          isOpen ? 'max-h-[600px] opacity-100 pb-7' : 'max-h-0 opacity-0'
        }`}
      >
        <p className="text-[16px] text-muted leading-[1.7] pr-14">
          {answer}
        </p>
      </div>
    </div>
  );
}

export default function FAQAccordion({
  items = [],
  defaultOpen = -1,
  className = '',
}) {
  const [openIdx, setOpenIdx] = useState(defaultOpen);
  
  return (
    <div className={className}>
      {items.map((item, i) => (
        <FAQItem
          key={i}
          question={item.question}
          answer={item.answer}
          isOpen={openIdx === i}
          onToggle={() => setOpenIdx(openIdx === i ? -1 : i)}
        />
      ))}
    </div>
  );
}